import { APP_NAME } from '@/utils/constants';
import { useRouteProps } from 'umi';

const useRouteName = () => {
  const { name } = useRouteProps<{ name: string }>();
  return name || APP_NAME;
};

export default useRouteName;
